import jQuery from "jquery";

export function getRadioVal(radio_name){return jQuery(`input[name="${radio_name}"]:checked`).val();}
  
export function setRadioVal(radio_name,value_to_set){
    var radios = jQuery('input:radio[name='+radio_name+']'); //Get all radio buttons of that set
    radios.filter("[value='"+value_to_set+"']").prop('checked', true); //CSS filter down to only the value you want to select
  }

  export function flashMessage(msg,alertclass){var myalert = `<div class="alert alert-${alertclass}">${msg}</div>`;jQuery("#flashed_messages").append(myalert);}
  
export function searchToObject(search) { //convert window.location.search to json
    return search.substring(1).split("&").reduce(function(result, value) {var parts = value.split('=');if (parts[0]) result[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);return result;}, {})}






//TODO: this needs to become a function, not an extension of jquery function
jQuery.fn.radioTabbable = function () {
    var groups = [];

    // group the inputs by name
    jQuery(this).each(function () {
      var el = this;
      var thisGroup = groups[el.name] = (groups[el.name] || []);
      if (jQuery('#' + this.id + ' + label').is(':visible')) { //TODO: fix this bug, + label isn't found
        thisGroup.push(el);
      }
    });

    jQuery(this).on('keydown', function (e) {
      setTimeout(function () {
        var el = e.target;
        var thisGroup = groups[el.name] = (groups[el.name] || []);
        var indexOfTarget = thisGroup.indexOf(e.target);

        if (e.keyCode === 9) {
          if (indexOfTarget < (thisGroup.length - 1) && !(e.shiftKey)) {
            thisGroup[indexOfTarget + 1].focus();
          }
          else if (indexOfTarget > 0 && e.shiftKey) {
            thisGroup[indexOfTarget - 1].focus();
          }
        }
      });
    });
  };

    function formatTimeSince(seconds) {
        var interval = seconds / 31536000;
        if (interval > 1) {
          var floor = Math.floor(interval)
          if (floor==1){return floor + " year";}
          else{return floor + " years";}
        }
        interval = seconds / 2592000;
        if (interval > 1) {
          var floor = Math.floor(interval)
          if (floor==1){return floor + " month";}
          else{return floor + " months";}
        }
        interval = seconds / 86400;
        if (interval > 1) {
          var floor = Math.floor(interval)
          if (floor==1){return floor + " day";}
          else{return floor + " days";}
        }
        interval = seconds / 3600;
        if (interval > 1) {
          var floor = Math.floor(interval)
          if (floor==1){return floor + " hour";}
          else{return floor + " hours";}
        }
        interval = seconds / 60;
        if (interval > 1) {
          var floor = Math.floor(interval)
          if (floor==1){return floor + " minute";}
          else{return floor + " minutes";}
        }
          var floor = Math.floor(seconds)
          if (floor==1){return floor + " second";}
          else{return floor + " seconds";}
      }